"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var base_1 = tslib_1.__importDefault(require("../base"));
var account_1 = tslib_1.__importDefault(require("./account"));
var currency_1 = tslib_1.__importDefault(require("./currency"));
var address_1 = tslib_1.__importDefault(require("./address"));
var BankResource = /** @class */ (function (_super) {
    tslib_1.__extends(BankResource, _super);
    function BankResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BankResource.endpoint = '/banks';
    BankResource.MODEL_NAME = 'bank';
    BankResource.related = {
        currency: currency_1.default,
        address_physical: address_1.default,
        address_mailing: address_1.default,
        default_account_cash: account_1.default,
        default_account_clearing: account_1.default,
        default_account_deposits: account_1.default,
        default_account_discount: account_1.default,
    };
    return BankResource;
}(base_1.default));
exports.default = BankResource;
//# sourceMappingURL=bank.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/resources/system/bank.js
// module id = OwUp
// module chunks = 0